import React from "react";

import Layout from "../components/Layout";

const HomePage = () => {
  return <Layout></Layout>;
};

export default HomePage;
